import { render, staticRenderFns } from "./link-card.vue?vue&type=template&id=3132cb08&scoped=true&"
import script from "./link-card.vue?vue&type=script&lang=js&"
export * from "./link-card.vue?vue&type=script&lang=js&"
import style0 from "./link-card.vue?vue&type=style&index=0&id=3132cb08&prod&lang=scss&"
import style1 from "./link-card.vue?vue&type=style&index=1&id=3132cb08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132cb08",
  null
  
)

export default component.exports